import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Logo flies from the pressed "+ 1 MERE" button to the cart icon.
export function OneMoreFx() {
  const [bursts, setBursts] = useState([]);
  useEffect(() => {
    const h = (e) => {
      const cart = document.querySelector('[data-testid="header-cart"], [data-testid="bottom-nav-cart"]');
      const r = cart?.getBoundingClientRect();
      const to = r ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : { x: window.innerWidth - 40, y: 40 };
      const id = Date.now() + Math.random();
      setBursts((b) => [...b, { id, from: e.detail, to }]);
      setTimeout(() => setBursts((b) => b.filter((x) => x.id !== id)), 900);
    };
    window.addEventListener("b1m:onemore", h);
    return () => window.removeEventListener("b1m:onemore", h);
  }, []);
  return (
    <div className="pointer-events-none fixed inset-0 z-[90]" data-testid="one-more-fx">
      <AnimatePresence>
        {bursts.map((b) => (
          <React.Fragment key={b.id}>
            <motion.img
              src="/brand/logo.png" alt=""
              initial={{ x: b.from.x - 28, y: b.from.y - 28, scale: 0.4, opacity: 0, rotate: -20 }}
              animate={{ x: [b.from.x - 28, (b.from.x + b.to.x) / 2 - 28, b.to.x - 28], y: [b.from.y - 28, Math.min(b.from.y, b.to.y) - 120, b.to.y - 28], scale: [0.4, 1.15, 0.3], opacity: [0, 1, 0], rotate: [-20, 10, 0] }}
              transition={{ duration: 0.75, ease: "easeInOut", times: [0, 0.5, 1] }}
              className="absolute h-14 w-14 rounded-full object-contain drop-shadow-[0_0_14px_rgba(236,30,121,0.8)]"
            />
            <motion.span
              initial={{ x: b.from.x, y: b.from.y - 10, opacity: 0, scale: 0.6 }}
              animate={{ y: b.from.y - 60, opacity: [0, 1, 0], scale: [0.6, 1.2, 1] }}
              transition={{ duration: 0.7 }}
              className="absolute -translate-x-1/2 whitespace-nowrap font-brand text-sm font-black text-primary"
            >BARE 1 MERE!</motion.span>
          </React.Fragment>
        ))}
      </AnimatePresence>
    </div>
  );
}
